import gql from "graphql-tag";

export const MY_HR_PAYCARDS_SUBSCRIPTION = gql`
  subscription paycardsSubscription {
    paycardsSubscription
  }
`;
